import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { Link } from "react-router-dom";

const pages = [
  {name:'Dashboard', page:'/activations'}, 
  {name:'Summary', page:'/reports/RptActivations'},
  {name:'Activations', page:'/reports/RptActivationDataExport'},
  {name:'Downloads', page:'/reports/RptESDDownloadLog'},
  {name:'Licenses', page:'/reports/RptExportLicenses'},
  {name:'XML Parser', page:'/license'},
];

const settings = [
  //{name:'Profile',  page:'profile'}, 
  //{name:'Account',  page:'account'}, 
  {name:'Dashboard', page:'reportlist'}, 
  {name:'Logout', page:'/login/logout'}];

export default function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (event) => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = (event) => {
    setAnchorElUser(null);
  };



  return (
    <AppBar position="static">
      <Container maxWidth="false">
        <Toolbar disableGutters>
          <img alt="netlib" width="30" src="/images/netliblogosq.jpg" style={{ marginRight: '10px', }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/ReportList"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'Helvetica,Arial',
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            NetLib Security
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((item) => (
                <Link  style={{ textDecoration: 'none', display: 'block', color: 'black' }} key={item.page} to={item.page}>
                <MenuItem key={item.page} onClick={handleCloseNavMenu}>                  
                  <Typography textAlign="center">{item.name}</Typography>                 
                </MenuItem>
                </Link>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'Helvetica,Arial',
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            NetLib Security
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((item) => (
              <Link style={{ textDecoration: 'none', display: 'block', color: 'black' }} key={item.page} to={item.page}>
              <Button
                key={item.page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {item.name}
              </Button>
              </Link>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="NetLib User" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <Link style={{ textDecoration: 'none', display: 'block', color: 'black' }} key={setting.page} to={setting.page}>
                <MenuItem key={setting.name} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting.name}</Typography>
                </MenuItem>
                </Link>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}